import * as amplitude from '@amplitude/analytics-browser';

/**
 * Public self-onboarding Amplitude events (distinct names for funnel charts).
 * Never attach email, password, tokens, or other PII.
 */
export const SELF_ONBOARDING_AMPLITUDE_EVENTS = {
  campaignRequired: 'plg-self-onboarding-campaign-required',
  signupCompanyView: 'plg-self-onboarding-signup-company',
  signupYouView: 'plg-self-onboarding-signup-you',
  signupBackToCompany: 'plg-self-onboarding-signup-back',
  registerSuccess: 'plg-self-onboarding-register-success',
  registerEmailTaken: 'plg-self-onboarding-register-email-taken',
  registerError: 'plg-self-onboarding-register-error',
  checkEmailView: 'plg-self-onboarding-check-email',
  resendClick: 'plg-self-onboarding-resend',
  verifyingView: 'plg-self-onboarding-verifying',
  verifySuccess: 'plg-self-onboarding-verify-success',
  verifyError: 'plg-self-onboarding-verify-error',
  brandingView: 'plg-self-onboarding-branding',
  brandingContinue: 'plg-self-onboarding-branding-continue',
} as const;

export type SelfOnboardingAmplitudeEvent =
  (typeof SELF_ONBOARDING_AMPLITUDE_EVENTS)[keyof typeof SELF_ONBOARDING_AMPLITUDE_EVENTS];

export type SelfOnboardingAmplitudeProps = {
  campaign?: string | null;
  country?: string | null;
  language?: string | null;
  authMethod?: 'password' | 'sso';
  reason?: string;
};

/**
 * Fire a PLG self-onboarding Amplitude event. Safe no-op when the SDK is
 * unavailable; Amplitude is only initialized outside `devEnvironment`.
 */
export function trackSelfOnboarding(
  event: SelfOnboardingAmplitudeEvent,
  props: SelfOnboardingAmplitudeProps = {}
): void {
  if (!amplitude) {
    return;
  }
  const payload: Record<string, string> = {};
  if (props.campaign) {
    payload.campaign = props.campaign;
  }
  if (props.country) {
    payload.country = props.country;
  }
  if (props.language) {
    payload.language = props.language;
  }
  if (props.authMethod) {
    payload.authMethod = props.authMethod;
  }
  if (props.reason) {
    payload.reason = props.reason;
  }
  try {
    amplitude.logEvent(event, payload);
  } catch {
    /* analytics must never break the funnel */
  }
}
